import styled from '@emotion/styled';

import { forDesktop, forMobile } from '@/design-system';

export const HeadingRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  minWidth: 0,
}));

export const HeadingInfo = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  color: theme.colors.icon.secondary,

  svg: {
    width: 16,
    height: 16,
  },
}));

export const PerformanceLayout = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1.2fr) minmax(360px, 1fr)',
  gap: theme.spacing[24],
  marginTop: theme.spacing[16],

  [forMobile]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: theme.spacing[16],
  },

  [forDesktop]: { marginTop: theme.spacing[24] },
}));
